import FeatureGates from '@atlaskit/feature-gate-js-client';

// ALL FEATURE GATES SHOULD BE CALLBACKS
// CHECK IF USER IS LOGGED IN - if not, do not check for the feature gate

/**
 * UPP-UI-FEATURE-GATE-TEST
 * @link https://switcheroo.atlassian.com/ui/gates/ab5c3a4c-7985-4532-bd93-cb0ae3160a25/key/upp-ui-feature-gate-test
 * @description This feature gate is used to test the feature gate functionality in UPP UI
 * @returns true if the user should see the feature
 */
export const uppUiFeatureGateTestIsActive = (): boolean => FeatureGates.checkGate('upp-ui-feature-gate-test') ?? false;

/**
 * PRODUCT-ID-TO-NODE-ID-CHANGE
 * @link https://switcheroo.atlassian.com/ui/gates/02faeae7-dda3-4d18-9ab7-bbbbfc795ce2/key/product-id-to-node-id-change
 * @description This feature gate is used to test the feature gate functionality in UPP UI
 * @returns true if the user should see the feature
 */
export const productIdToNodeIdChangeIsActive = (): boolean => {
  if (process.env.REACT_APP_USE_MOCK_NETWORK_HANDLER === 'true') {
    return true;
  }

  return FeatureGates.checkGate('product-id-to-node-id-change') ?? false;
};

/**
 * Account Switcher
 * @link https://switcheroo.atlassian.com/ui/gates/7273b874-7130-439f-9f4e-c5c26b9fedca/key/community-account-switcher
 */
export const accountSwitcherIsActive = () => FeatureGates.checkGate('community-account-switcher') ?? false;

/**
 * Forums V2
 * @link https://switcheroo.atlassian.com/ui/gates/81652019-f9a1-4a71-bc2c-3dd5bd60fbd5/key/smart-community
 * @description This feature gate controls the forums v2 feature
 * @returns true if the user should see the forums v2 feature
 */
export const forumsV2IsActive = (): boolean => FeatureGates.checkGate('smart-community') ?? false;
// using for local development
// export const forumsV2IsActive = (): boolean => t

/**
 * New Navigation
 * @link https://switcheroo.atlassian.com/ui/gates/9912bd84-cf3a-4586-88b2-e61641977351/key/community_new_top_navigation
 * @description This feature gate controls the new navigation feature
 * @returns true if the user should see the new navigation feature
 */
export const newNavigationIsActive = (): boolean => FeatureGates.checkGate('community_new_top_navigation') ?? false;

/**
 * Champions Auth Signup
 * @link https://switcheroo.atlassian.com/ui/gates/40e0ce8b-3e3a-42e3-8415-c23c7f1938ab/key/community-champions-auth-signup
 * @description This feature gate controls access to the new auth-gated Champions signup flow.
 * When enabled, users will be directed to the internal /champions/apply page (requires authentication).
 * When disabled, users will be directed to the external Salesforce signup page.
 * @returns true if the user should see the new auth-gated signup flow
 */
export const championsAuthSignupIsActive = (): boolean =>
  FeatureGates.checkGate('community-champions-auth-signup') ?? false;

/**
 * HLV Vanilla Migration
 * @link https://switcheroo.atlassian.com/ui/gates/f7ed6e29-2107-4826-8a9a-c9128d87f34b/key/community-forums-hlv-vanilla
 * @description Umbrella gate for the Khoros → HLV Vanilla forums migration.
 * ON = Vanilla behavior (/forums/entry/*), OFF = legacy Khoros. Reuse across
 * all Vanilla-vs-Khoros branches. Rollout: ddev → stg → prod. Remove gate +
 * Khoros branches post-migration.
 * @returns true when the environment should behave as HLV Vanilla
 */
export const hlvVanillaMigrationIsActive = (): boolean =>
  FeatureGates.checkGate('community-forums-hlv-vanilla') ?? false;

/**
 * HLV Vanilla Prerelease URL
 * @description Temporary gate to route HLV traffic to the prerelease /new-hlv-forums path.
 * OFF = canonical /forums URL, ON = prerelease /new-hlv-forums URL.
 * This gate is only meaningful after community-forums-hlv-vanilla is active.
 */
export const hlvVanillaPrereleaseUrlIsActive = (): boolean =>
  FeatureGates.checkGate('community-forums-hlv-prerelease-url') ?? false;
